import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e65569c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cell-box xag-container" }
const _hoisted_2 = { class: "cell auto-height" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "describe-header title" }, "设备故障照片", -1))
const _hoisted_4 = {
  key: 0,
  class: "xag-flex images-box"
}
const _hoisted_5 = ["onClick", "src"]
const _hoisted_6 = { class: "cell auto-height" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "describe-header title" }, "故障描述", -1))
const _hoisted_8 = {
  key: 0,
  class: "describe",
  style: {"margin-top":"4px"}
}
const _hoisted_9 = { class: "cell xag-flex-lr" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title xag-flex-center" }, "维修网点", -1))
const _hoisted_11 = {
  key: 0,
  class: "content xag-ellipsis",
  style: {"width":"calc(100% - 98px)"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xag-page__footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, { title: "提单内容" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.imgs.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgs, (url, i) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: i,
                  onClick: ($event: any) => (_ctx.getBigImages(i)),
                  src: url,
                  alt: ""
                }, null, 8, _hoisted_5))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        (_ctx.describe)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.describe), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        (_ctx.cacheNetworkpointName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.cacheNetworkpointName), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_12
  ], 64))
}